export default "__VITE_ASSET__B2dZSi7G__"